import React from 'react';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/src/types/ProductLineId';
import clsx from 'clsx';
import { createStyles } from './styles';

export interface ProductLineCardProps {
  pLineId: ProductLineId | 'Favorites';
  onCardClick: (e: React.SyntheticEvent<HTMLLIElement>) => void;
  icon: JSX.Element;
  label: string;
  className?: string;
}

const ProductLineCard = ({ pLineId, icon, label, className, onCardClick }: ProductLineCardProps): JSX.Element => {
  const classes = createStyles();
  return (
    <li
      id={`product-details-li-${pLineId}`}
      className={clsx(classes.card, className || classes.defaultCard)}
      onClick={onCardClick}
      data-product-line={pLineId}
      role="menuitem"
      tabIndex={0}
      onKeyDown={onCardClick}
    >
      {icon}
      <h3 className={classes.cardTitle}>{label}</h3>
    </li>
  );
};

export default ProductLineCard;
